import React, { memo } from 'react'
import Link from 'next/link'
import Button from '@mui/material/Button'
import Box from '@mui/material/Box'
import MuiLink from '@mui/material/Link'
import Typography from '@mui/material/Typography'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import CardActions from '@mui/material/CardActions'
import { FormattedMessage } from 'react-intl'
import sx from './styles'

const FaqCard = ({ variantComponentFaqTitle = 'h4', item, formattedMessageEnabled = true }) => {
  const ComponentList = item.listType === 'ordered' ? 'ol' : 'ul'
  return (
    <Card
      variant="outlined"
      sx={sx.root}
    >
      <CardContent>
        {item.question && (
          <Typography
            variant="subtitle2"
            component={variantComponentFaqTitle}
            sx={sx.cardTitle}
          >
            {formattedMessageEnabled
              ? (<FormattedMessage id={item.question} />)
              : (item.question)}
          </Typography>
        )}

        {item.response && (
          <Typography
            variant="body2"
            component="p"
            mt={2}
            sx={sx.cardTextBody}
          >
            {formattedMessageEnabled
              ? (
                <FormattedMessage
                  id={item.response}
                  values={{ br: <br />, minutes: item.minutesValue ? item.minutesValue : '' }}
                />
              ) : (item.response)}
          </Typography>
        )}
        {item.responseList && item.responseList.length > 0 && (
          <Box component={ComponentList}>
            {item.responseList.map((subtext, index) => (
              <Box
                component="li"
                sx={sx.listItem}
                key={`response-unordered-${index}`}
              >
                <Typography
                  variant="body2"
                >
                  {formattedMessageEnabled
                    ? (
                      <FormattedMessage
                        id={subtext}
                      />
                    ) : (subtext)}
                </Typography>
              </Box>
            ))}
          </Box>
        )}

        {item.subsections && item.subsections.length > 0 && (
          <>
            {item.subsections.map((subsection) => (
              <Box key={`item-subtitle-${subsection.title}`}>
                {subsection.questions.map((subitem) => (
                  <Box key={`subquestion-${subitem.question}`}>
                    <Typography
                      variant="body2"
                    >
                      {formattedMessageEnabled
                        ? (<FormattedMessage id={subitem.question} />)
                        : (subitem.question)}
                    </Typography>
                    {subitem?.responseList?.length > 0 && (
                      <Box
                        style={sx.subitemContainer}
                        component={subitem?.listType === 'ordered' ? 'ol' : 'ul'}
                      >
                        {subitem?.responseList.map((resp, subindex) => (
                          <Box
                            component="li"
                            style={sx.listItem}
                            key={`response-ordered-${subindex}`}
                          >
                            <Typography
                              variant="body2"
                              sx={sx.bodyText}
                            >
                              {formattedMessageEnabled
                                ? (
                                  <FormattedMessage
                                    id={resp}
                                  />
                                ) : (resp)}
                            </Typography>
                          </Box>
                        ))}
                      </Box>
                    )}
                  </Box>
                ))}
              </Box>
            ))}
          </>
        )}

        {item.note && (
          <Typography
            variant="body2"
          >
            {formattedMessageEnabled ? (
              <FormattedMessage
                id={item.note}
              />
            ) : (item.note)}
          </Typography>
        )}

      </CardContent>

      {
        item?.button?.href && (
          <CardActions sx={sx.cardLink}>
            <Link
              href={item.button.href}
              passHref
            >
              {item?.button?.variant === 'button' ? (
                <Button
                  variant="outlined"
                  color="primary"
                  aria-label={item.button.text}
                  sx={sx.button}
                >
                  {item.button.text}
                </Button>
              ) : (
                <MuiLink sx={sx.link}>
                  <Typography
                    variant="body1"
                  >
                    {item.button.text}
                  </Typography>
                </MuiLink>
              )}

            </Link>
          </CardActions>
        )
      }
    </Card>
  )
}

export default memo(FaqCard)
